// Portado de src/components/Footer.astro (site Astro).
// A linha "Google · 5,0 · 204 avaliações" do original foi omitida: números e
// nota do Google não podem ser publicados enquanto estão em conferência.
import { MAPS_BUSCA, MEDICO, MENU, NAP, REDES, SITE } from "@/lib/itv/site";
import { useAgendamentoLink } from "@/lib/itv/agendamento";

const itemTratamentos = MENU.find((i) => i.label === "Tratamentos");
const filhosTratamentos = itemTratamentos?.filhos ?? [];
const itemAvaliacao = MENU.find((i) => i.label === "Avaliação 360°");

const tratamentos = [
  { label: "Avaliação 360°", href: itemAvaliacao?.href ?? "/tratamentos/avaliacao-360/" },
  ...filhosTratamentos.map((f) => ({ label: f.label, href: f.href })),
];

const navegacao = [
  { label: "Sobre o Dr. Thiago", href: "/sobre/" },
  { label: "Saúde com Propósito", href: "/saude-com-proposito/" },
  { label: "Blog", href: "/blog/" },
  { label: "Vídeos", href: "/videos/" },
  { label: "Teleconsulta", href: "/consulta-online/" },
  { label: "Consultório em Bauru", href: "/bauru/" },
];

export function Footer() {
  const agendar = useAgendamentoLink();
  const ano = new Date().getFullYear();

  return (
    <footer className="rodape">
      <div className="colunas">
        <div className="col col-marca">
          <img className="logo" src="/img/logo-itv-166.webp" srcSet="/img/logo-itv-166.webp 1x, /img/logo-itv-249.webp 2x" width={106} height={56} loading="lazy" alt={SITE.clinica} />
          <p className="nome">{SITE.clinica}</p>
          <p className="resumo">
            Saúde integral: composição corporal, performance, longevidade e qualidade de vida.
          </p>
          <p className="registro">{MEDICO.crm}</p>
          {MEDICO.especialidades.map((e) => (
            <p className="registro" key={e.rqe}>
              {e.rqe} · {e.nome}
            </p>
          ))}
        </div>

        <nav className="col" aria-labelledby="rodape-tratamentos">
          <h2 className="rotulo" id="rodape-tratamentos">
            Tratamentos
          </h2>
          <ul>
            {tratamentos.map((t) => (
              <li key={t.label}>
                <a href={t.href}>{t.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="col" aria-labelledby="rodape-navegacao">
          <h2 className="rotulo" id="rodape-navegacao">
            Navegação
          </h2>
          <ul>
            {navegacao.map((n) => (
              <li key={n.href}>
                <a href={n.href}>{n.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="col">
          <h2 className="rotulo">Consultório e contato</h2>
          <address>
            <a className="endereco-maps" href={MAPS_BUSCA}>
              <span>{NAP.logradouro}</span>
              <span>{NAP.bairro}, {NAP.cidade}–{NAP.uf}, {NAP.cep}</span>
            </a>
            <p>
              <a href={`tel:${NAP.telefoneE164}`}>{NAP.telefone}</a>
            </p>
            <p>
              <a href={`mailto:${NAP.email}`}>{NAP.email}</a>
            </p>
          </address>
          <p className="redes">
            <a href={agendar}>
              WhatsApp
            </a>{" "}
            ·{" "}
            <a href={REDES.instagram}>
              Instagram
            </a>{" "}
            ·{" "}
            <a href={REDES.youtube}>
              YouTube
            </a>
          </p>
        </div>
      </div>

      <p className="legal">
        Responsável técnico: {SITE.nome}, {MEDICO.crm}. As informações deste site têm caráter
        educativo e não substituem consulta médica. Resultados variam de pessoa para pessoa.
        &nbsp;·&nbsp; © {ano} Instituto Dr. Thiago Viana
      </p>
    </footer>
  );
}
